
import axios from "axios";
import rutas from '@/assets/utils/rutas.json';


const getTiposCoberturaSelect = async () => {
  const query = `
    query {
      allTipocobertura {
        id
        descripcion
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });

    const data =  response.data.data.allTipocobertura
      .map(item => ({
        value: item.id,
        text: item.descripcion,
      }))
    
    // console.log('opciones cobertura', data);
    return data

  } catch (error) {
    console.error("Error fetching Tipo cobertura:", error);
  }
}


const getTiposSegurosSalud = async () => {

  const query = `
    query {
      allSegurosalud {
        id
        descripcion
        codigo
      }
    }     
  `;

  try{
    const response = await axios.post(rutas.axios + 'api', { query });

    const data =  response.data.data.allSegurosalud;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion,
      code: item.codigo
    }))
    // console.log('tipos seguros', dataMap);

    return dataMap;

  }catch(error){
    console.error("Error fetching Tipos seguro salud:", error);
    return null;
  }

}


const getSegurosPrivados = async () => {

  const query = `
    query {
      allSeguroprivado {
        id
        descripcion
      }
    }
  `;

  try{
    const response = await axios.post(rutas.axios + 'api', { query });
    const data =  response.data.data.allSeguroprivado;
    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('seguros privados', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error al traer los seguros privados', error);
    return null;
  }
}



const getTiposBono = async () => {

  const query = `
    query {
      allTipobono {
        id
        descripcion
      }
    }
  `;

  try{
    const response = await axios.post(rutas.axios + 'api', { query });
    const data =  response.data.data.allTipobono;
    
    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('tipos bono', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error al traer los tipos bono', error);
    return null;
  }
} 

export const segurosService = {
  getTiposCoberturaSelect,

  getTiposSegurosSalud,
  getSegurosPrivados,
  getTiposBono
}